<template>
  <div class="important-days section-inner">
    <h1 class="important-days__title">
      {{ text.title }}
    </h1>
    <div class="important-days__content">
      <important-days-app :text="text" />
      <div class="important-days__image-wrapper">
        <img
          class="important-days__image"
          :src="holidayImg"
          width="459"
          height="502"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import holidayImg from './images/holidays.jpg'
import ImportantDaysApp from './important-days-app'

export default {
  name: 'ImportantDays',
  components: {ImportantDaysApp},
  props: {
    text: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      holidayImg
    }
  }
}
</script>

<style lang="scss">
.important-days {
  box-sizing: border-box;
  width: 100%;
  margin-top: 21px;
  margin-bottom: 165px;

  &__title {
    position: relative;
    display: flex;
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
    font-weight: 600;
    font-size: 30px;
    line-height: 1.53;
    text-align: center;
    text-transform: uppercase;

    &::after {
      position: absolute;
      bottom: -24px;
      width: 150px;
      height: 4px;
      background-color: #BC873A;
      content: '';
    }
  }

  &__content {
    display: grid;
    grid-template-columns: 1fr 460px;
    gap: 30px;
    margin-top: 100px;
  }

  &__image-wrapper {
    display: flex;
  }

  &__image {
    width: 100%;
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    &__title {
      font-size: 18px;
    }

    &__content {
      grid-template-columns: 1fr;
      margin-top: 68px;
    }

    &__image-wrapper {
      display: none;
    }
  }
}
</style>
